import React, { useEffect, useState } from 'react';
import { Box, Grid, Modal, MenuItem, Select } from '@mui/material';
import RoundButton from '../components/roundButton';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';

export default function ModalLoad({
  open,
  modalValue,
  handleClose,
  handleSubmit,
  savedPartNumber
}) {
  const [submitValue, setSubmitVal] = useState('');
  const [submitPartName, setSubmitPartName] = useState('');

  const [loadData, setLoadData] = useState([]);

  useEffect(() => {
    if (savedPartNumber) {
      setLoadData(savedPartNumber);
      if (savedPartNumber?.length > 0) {
        setSubmitVal(savedPartNumber[0].partNumber);
        setSubmitPartName(savedPartNumber[0].title);
      }
    }
  }, [savedPartNumber]);
  return (
    <Modal open={open} onClose={handleClose}>
      <Box className="modal-common load-modal">
        <Grid container>
          <Grid item xs={11} sm={11} md={11} lg={11} className="align-center">
            <h5 className="m-1">{modalValue?.heading}</h5>
          </Grid>
          <Grid
            item
            xs={1}
            sm={1}
            md={1}
            lg={1}
            onClick={e => {
              handleClose(true, submitPartName);
            }}
          >
            <CloseRoundedIcon />
          </Grid>

          {loadData && loadData?.length > 0 ? (
            <Select
              value={submitValue}
              onChange={e => {
                setSubmitVal(e.target.value);
                let title = savedPartNumber.filter(
                  m => m.partNumber == e.target.value
                )[0].title;
                setSubmitPartName(title);
              }}
              sx={{
                width: '100%',
                '& div': { padding: '5px', paddingLeft: '15px' }
              }}
              inputProps={{ 'aria-label': 'Without label' }}
            >
              {loadData?.map((item, index) => {
                return (
                  <MenuItem key={index} value={item.partNumber}>
                    {item.title}
                  </MenuItem>
                );
              })}
            </Select>
          ) : (
            <>
              <Grid item xs={12} sm={12} md={12} lg={12}>
                You do not have any saved configurations.
              </Grid>
            </>
          )}

          <Grid item xs={0} sm={3} md={3} lg={3}></Grid>

          {loadData && loadData?.length > 0 ? (
            <>
              <Grid item xs={4} sm={3} md={3} lg={3} className="pr-h-5">
                <RoundButton
                  name={modalValue?.button}
                  onClick={async () => {
                    await handleSubmit(submitValue, 'load', submitPartName);
                    handleClose(false);
                  }}
                />
              </Grid>
              <Grid item xs={4} sm={3} md={3} lg={3} className="pr-h-5">
                <RoundButton
                  name={modalValue?.deleteButton}
                  onClick={() => {
                    handleSubmit(submitValue, 'remove', submitPartName);
                  }}
                />
              </Grid>
            </>
          ) : (
            <></>
          )}
          <Grid item xs={4} sm={3} md={3} lg={3} className="pr-h-5">
            <RoundButton
              name={modalValue?.cancelButton}
              onClick={e => {
                handleClose(true, submitPartName);
              }}
            />
          </Grid>
        </Grid>
      </Box>
    </Modal>
  );
}
